<template>
    <div>
        <Title :title="'习题管理'" :noBorder="true"></Title>
        <Menu mode="horizontal" :theme="'light'" :active-name="activeName" class="tabs" @on-select="menuChange">
            <MenuItem name="Exercise">
                题库管理
            </MenuItem>
            <MenuItem name="exam">
                习题组卷
            </MenuItem>
        </Menu>
        <div>
<!--            <keep-alive>-->
                <component :is="currentPage" :id="this.$route.params.id"></component>
<!--            </keep-alive>-->
        </div>
    </div>
</template>

<script>
    import Title from "../../ability/components/title";
    import Exercise from "./example/exercise"
    import Exam from "./example/exam"
    import {mapActions, mapState} from 'vuex'
    export default {
        name: "example",
        components: {
            Title,
            Exercise,
            Exam
        },
        data(){
            return {
                currentPage:'Exercise',
                activeName:'Exercise',
            }
        },
        methods: {
            ...mapActions({
                getDirection: 'courseManage/getDirection',
            }),
            menuChange(name){
                this.$route.params.id = 0
                this.currentPage = name
            }
        },
        mounted () {
            this.getDirection()
            if(this.$route.params.id){
                this.currentPage = 'Exam'
                this.activeName = 'exam'
            }
        },
    }
</script>
<style lang="less">
   .tabs{
       height: 40px;
       line-height: 40px;
   }
</style>
<style scoped lang="less">
</style>
